module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/scss/icons/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles